import { generateSeoString } from '../../utils/articleUtils'
import { AlmanacFileTitleContainer } from './AlmanacFileTitleContainer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { computed, values } from 'mobx'
import { PropsWithChildren } from 'react'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ButtonProps } from 'components/Button/Types'
import { AssetType } from 'types'

interface Props extends Pick<ButtonProps, 'size'> {
  id: string
  assetType: AssetType
  forceOpen?: boolean
  autoFocus?: boolean
  withChannels?: boolean
  isDisabled?: boolean
}

export const AlmanacFileTitleWithTree = observer(
  ({
    id,
    assetType,
    forceOpen = false,
    autoFocus = false,
    withChannels = false,
    children,
    size,
    isDisabled = false,
  }: PropsWithChildren<Props>) => {
    const handbookItems = useRootStore().handbooks.items
    const itemKey = assetType === 'Project' ? 'folder' : 'document'
    const treeItem = computed(() => values(handbookItems).find((item) => item.data[itemKey]?.key === id)).get()
    const queryClient = useQueryClient()
    const workspaceId = useCurrentWorkspaceId()

    const resetFilesQueries = () => queryClient.invalidateQueries(['workspace', workspaceId, 'files'])

    const updateFileInTree = (newTitle: string, newEmoji: string | null) => {
      if (!treeItem) {
        resetFilesQueries()

        return
      }

      const header_emoji = newEmoji
      const title = newTitle
      const seo_string = generateSeoString(title, id)

      return treeItem.updateAttrs({
        title,
        [itemKey]: { ...treeItem.data[itemKey], seo_string, header_emoji },
      })
    }

    return (
      <AlmanacFileTitleContainer
        id={id}
        onChange={updateFileInTree}
        onUpdateFinish={resetFilesQueries}
        assetType={assetType}
        performAsyncUpdate
        forceOpen={forceOpen}
        autoFocus={autoFocus}
        withChannels={withChannels}
        size={size}
        isDisabled={isDisabled}
      >
        {children}
      </AlmanacFileTitleContainer>
    )
  },
)
